import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TProjectData } from "../types/project";

interface ProjectStore {
	project: TProjectData | null;
	setProject: (project: TProjectData) => void;
}

export const useProjectStore = create<ProjectStore>()(
	persist(
		(set) => ({
			project: null,
			setProject: (project: TProjectData) => set({ project }),
		}),
		{
			name: "project-store",
		}
	)
);
